import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const TELEGRAM_USERNAME = "highnintyfive";
export const TELEGRAM_URL = `https://t.me/${TELEGRAM_USERNAME}`;
export const PHONE = "+1 (904) 923-0251";
export const PHONE_TEL = "+19049230251";

export const LOGO_URL =
    "https://customer-assets.emergentagent.com/job_eager-ganguly-6/artifacts/mh4p34h7_D0C13C03-2E61-4390-8F20-858AB177186C.png";

export const HERO_BG =
    "https://images.unsplash.com/photo-1770819878705-81772c210fb1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxuaWdodCUyMHJvYWQlMjBkYXJrfGVufDB8fHx8MTc3NzgwODE1Mnww&ixlib=rb-4.1.0&q=85";

export const ABOUT_BG =
    "https://images.unsplash.com/photo-1642975476474-759bd305627c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxzdW5zZXQlMjBoaWdod2F5JTIwZHJpdmV8ZW58MHx8fHwxNzc3ODA4MTUyfDA&ixlib=rb-4.1.0&q=85";
